import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit, AfterViewInit {
  @ViewChild(MatInput) matInput: MatInput;
  
  @Input() index: number = 0;
  @Input() focused: boolean = false;
  @Input() disabled: boolean = false;
  
  @Output() valueChange = new EventEmitter<{value: string, index: number}>();
  @Output() moveNext = new EventEmitter<number>();
  @Output() movePrevious = new EventEmitter<number>();
  @Output() otpPaste = new EventEmitter<ClipboardEvent>();
  
  otpControl: FormControl;
  
  private _value: string = '';
  @Input() 
  get value(): string {
    return this._value;
  }
  set value(val: string) {
    this._value = val;
    if (this.otpControl && this.otpControl.value !== val) {
      this.otpControl.setValue(val, { emitEvent: false });
    }
  }

  ngOnInit() {
    this.otpControl = new FormControl('');
    
    // Set initial value
    if (this.value) {
      this.otpControl.setValue(this.value, { emitEvent: false });
    }
    
    // Subscribe to value changes
    this.otpControl.valueChanges.subscribe(value => {
      this.handleValueChange(value);
    });
  }

  ngAfterViewInit() {
    if (this.focused && this.matInput) {
      setTimeout(() => {
        this.matInput.focus();
      }, 0);
    }
  }

  focus() {
    if (this.matInput) {
      this.matInput.focus();
    }
  }
  
  handleValueChange(value: string) {
    if (this.disabled) {
      // ignore changes while disabled
      return;
    }
    // Only accept single digit numbers
    if (value && value.length === 1 && /^[0-9]$/.test(value)) {
      this.valueChange.emit({value, index: this.index});
      this.moveNext.emit(this.index);
    } else if (value && value.length > 1) {
      // If multiple characters are entered, take only the first valid digit
      const firstDigit = value.match(/[0-9]/);
      if (firstDigit) {
        this.otpControl.setValue(firstDigit[0], { emitEvent: false });
        this.valueChange.emit({value: firstDigit[0], index: this.index});
        this.moveNext.emit(this.index);
      } else {
        this.otpControl.setValue('', { emitEvent: false });
        this.valueChange.emit({value: '', index: this.index});
      }
    } else if (value === '' || value == null) {
      this.valueChange.emit({value: '', index: this.index});
    } else if (value && !/^[0-9]$/.test(value)) {
      // Clear if not a number
      this.otpControl.setValue('', { emitEvent: false });
      this.valueChange.emit({value: '', index: this.index});
    }
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Backspace' && !this.otpControl.value) {
      event.preventDefault();
      this.movePrevious.emit(this.index);
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    this.otpPaste.emit(event);
  }
}